import { Component } from '@angular/core';

@Component({
  selector: 'app-terms-conditions',
  templateUrl: './terms-conditions.component.html',
  styleUrls: ['./terms-conditions.component.scss']
})
export class TermsConditionsComponent {

  currentLang: 'en' | 'ta' = 'en';

  switchLang(lang: 'en' | 'ta') {
    this.currentLang = lang;
  }
}
